import script from "./LiveChat.vue?vue&type=script&setup=true&lang=ts"
export * from "./LiveChat.vue?vue&type=script&setup=true&lang=ts"

import "./LiveChat.vue?vue&type=style&index=0&id=b630271a&lang=scss"

const __exports__ = script;

export default __exports__